import React from 'react';
import { InputFields } from 'ui/input/InputUI';
import './SystemList.css';

type SetSystem = (InputFields: InputFields) => void;

export type Props = {
    setSystem: SetSystem;
    userSystems?: InputFields[];
};

const examples: InputFields[] = [
    { name: 'Dragon Curve', forward: 'F', axiom: 'FX', rules: { X: 'X+YF', Y: 'FX-Y' }, angle: 90, step: 5, depth: 5 },
    { name: 'Snowflake', forward: 'F', axiom: 'F--F--F', rules: { F: 'F+F--F+F' }, angle: 60, step: 5, depth: 3 },
    { name: 'Sierpinski', forward: 'AB', axiom: 'A', rules: { A: 'B-A-B', B: 'A+B+A' }, angle: 60, step: 5, depth: 3 },
    { name: 'Plant', forward: 'F', axiom: 'F', rules: { F: 'FF-[-F+F+F]+[+F-F-F]' }, angle: 22, step: 5, depth: 3 },
];

const SystemRow = (setSystem: SetSystem, system: InputFields) => (
    <tr>
        <td>
            <div
                className="link"
                onClick={(): void => {
                    console.log(system);
                    setSystem({ ...system, name: system.name });
                }}
            >
                {system.name}
            </div>
        </td>
    </tr>
);

const SystemList = ({ setSystem, userSystems }: Props) => (
    <table className="systemList">
        <tr>
            <td>Examples</td>
        </tr>
        {examples.map((example) => SystemRow(setSystem, example))}
        <tr>
            <td>User Systems</td>
        </tr>
        {userSystems && userSystems.map((system) => SystemRow(setSystem, system))}
    </table>
);

export default SystemList;
